import React from 'react';
import s from './s.module.less';

// 原型 mcdIntro（09/21）：说明 No 打开的是什么，用 design system 的 info banner，不像又一个字段
export default function MedicaidIntro({ title, text }: { title: string; text: string }) {
    return (
        <div className={s.intro}>
            <svg viewBox="0 0 20 20" width="18" height="18" fill="#60A5FA" aria-hidden>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                />
            </svg>
            <span>
                {title}. {text}
            </span>
        </div>
    );
}
